@keyframes fadeInGradient {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animating {
  position: relative !important;
  color: white !important;
  transition: color 0.2s ease;
}

.animating::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(to right, #685edb, #d5257c);
  animation: fadeInGradient 0.35s ease forwards;
  z-index: 0;
}

.animating > * {
  position: relative;
  z-index: 1;
}
